import React from 'react'

import { colors } from 'helpers/colors'
import svgIcons from 'helpers/svgIcons'
import SvgRefreshOutline from 'components/reusable/svg/svg_refresh_outline'

const SubmitBtnIcon = ({ isCroppieEnabled, value }) => {
  if (isCroppieEnabled) return svgIcons.tick(colors.primary[500])

  if (value) return <SvgRefreshOutline size={22} color={colors.primary[500]} />

  return svgIcons.uploadIcon()
}

export default SubmitBtnIcon
